import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import logoMetagent from "../../assets/metagent-logo.webp";
import "./running-text.css";

gsap.registerPlugin(ScrollTrigger);

const RunningText = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    // Check if mobile
    const isMobile = window.innerWidth <= 768;

    const sentence1 = root.querySelector(".sentence1 p");
    const sentence2 = root.querySelector(".sentence2 p");
    const pinHeight = root.querySelector(".pin-height");
    const container = root.querySelector(".container");

    if (!sentence1 || !sentence2) {
      return;
    }

    // LENIS SMOOTH SCROLL (OPTIONAL - only for desktop)
    const lenis = !isMobile ? new Lenis({
      autoRaf: true,
    }) : null;

    // Mobile: Skip GSAP, use CSS animation instead
    if (isMobile) {
      return;
    }

    // Desktop: Full GSAP animations
    const ctx = gsap.context(() => {
      if (pinHeight && container) {
        ScrollTrigger.create({
          trigger: pinHeight,
          start: "top top",
          end: "bottom bottom",
          pin: container,
        });

        gsap.to([sentence1, sentence2], {
          yPercent: "-=100",
          ease: "power1.inOut",
          scrollTrigger: {
            trigger: pinHeight,
            start: "top top",
            end: "bottom bottom",
            scrub: 0.4,
          },
        });
      }

      // Running text animation for desktop
      document.fonts.ready.then(() => {
        // sentence1: bergerak dari kanan ke kiri
        gsap.to(sentence1, {
          x: -sentence1.clientWidth / 2,
          ease: "none",
          duration: 10,
          repeat: -1,
        });

        // sentence2: bergerak dari kiri ke kanan (arah berlawanan)
        gsap.fromTo(
          sentence2,
          { x: -sentence2.clientWidth / 2 },
          {
            x: sentence2.clientWidth / 2,
            ease: "none",
            duration: 10,
            repeat: -1,
          }
        );
      });
    }, root);

    return () => {
      ctx.revert();
      if (lenis) {
        lenis.destroy();
      }
    };
  }, []);

  return (
    <section className="mwg_effect024" ref={rootRef}>
      <div className="pin-height">
        <div className="container">
          <div className="sentences">
            <div className="sentence sentence1">
              <p>
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
              </p>
            </div>
            <div className="sentence sentence2">
              <p>
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
                <span> Metagent </span>
                <img className="glyph" src={logoMetagent} alt="Metagent" />
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default RunningText;
